import part1 from './cap_analyse_part1.json';
import part2 from './cap_analyse_part2.json';
import part3 from './cap_analyse_part3.json';

const mergeSections = (key) =>
  [...part1[key], ...part2[key], ...part3[key]].map(s => ({
    ...s,
    id: `S${s.numero}`,
  }));

const MODEL = {
  meta: part1.meta,
  qualite: mergeSections('qualite_sections'),
  potentiel: mergeSections('potentiel_sections'),
};

export default MODEL;
